import { render, staticRenderFns } from "./ScrollBox.vue?vue&type=template&id=22711ed0&scoped=true"
import script from "./ScrollBox.vue?vue&type=script&lang=js"
export * from "./ScrollBox.vue?vue&type=script&lang=js"
import style0 from "./ScrollBox.vue?vue&type=style&index=0&id=22711ed0&prod&scoped=true&lang=css"
import style1 from "./ScrollBox.vue?vue&type=style&index=1&id=22711ed0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22711ed0",
  null
  
)

export default component.exports